import { Component, inject, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Product } from '../../product/product.types';
import { ShopService } from '../shop.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { ProductsService } from '../../product/products.service';
import { ApiResponse } from '../../shared/common/types';
import { ProductComponent } from '../../product/product.component';
import { ShopComponent } from '../shop.component';

@Component({
  selector: 'app-shop-or-product',
  standalone: true,
  imports: [ProductComponent, ShopComponent],
  templateUrl: './shop-or-product.component.html',
})
export class ShopOrProductComponent {

  #activatedRoute = inject(ActivatedRoute);
  #router = inject(Router);
  #shopService = inject(ShopService);
  #productsService = inject(ProductsService);

  componentTypes = {
    shop: 'shop',
    product: 'product'
  };

  componentType: WritableSignal<string | null> = signal(null);

  #gotoProductDetail$ = toObservable(this.#shopService.gotoProductDetail);

  constructor() {
    this.#getProductsResolverData();
    this.#setUpProductNavigation();
  }

  #getProductsResolverData() {
    this.#activatedRoute.params.subscribe((params: any) => {
      this.#validateComponent(params)
    });
  }

  #validateComponent(params: any) {
    const slug = params['slug'];

    if (!slug) {
      this.#router.navigate(['/shop']);
      return;
    }

    const category = params['category'];
    const subcategory = params['subcategory'];

    const url = [category, subcategory, slug].join('/')

    this.#getItemType(url);
  }

  #getItemType(url: string) {
    this.#productsService.getProductByUrl(url, true, false).pipe(
      tap((product: Product | null) => {
        if (!product?.id) this.componentType.set(this.componentTypes.shop);
        else this.componentType.set(this.componentTypes.product);
      })
    ).subscribe()
  }

  #setUpProductNavigation() {
    this.#gotoProductDetail$.pipe(
      tap((url: string) => {
        if (!url) return;
        this.#getItemType(url);
      })
    ).subscribe()
  }
}
